import { Api, CacheableResource, GetApi, GetResource, Http } from '@mdd/api';
import { User } from '../../models';

export class GetCurrentUser extends CacheableResource<CacheableResource.Params, User> {
    private getApi: GetApi;
    private getResource: GetResource<Api.Rel, User>;

    constructor(http: Http) {
        super();
        this.getApi = new GetApi(http);
        this.getResource = new GetResource<Api.Rel, User>(http);
    }

    protected doExecute(params?: CacheableResource.Params): Promise<User> {
        return this.getApi.execute().then((api) => {
            return this.getResource
                .execute({
                    parent: api,
                    rel: 'account'
                })
                .then((x: User) => x);
        });
    }
}
